/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsForRegex": ["^draft"] }] */
import { produce } from 'immer';

import CALENDER_EVENTS, { CALENDER_EVENTS_ACTION_KEYS } from 'actionTypes/calenderEvents';
import { API_STATUS } from 'constants/enums';
import { getEventFormatedDate } from 'helpers/calendarEvents';
import { groupBy } from 'helpers/ramda';
import type { CalenderEvent, CalenderEventsState } from 'types/calenderEvents';

const INITIAL_STATE: CalenderEventsState = {
  apiStatus: API_STATUS.INITIAL,
  events: {},
  meta: {
    after: null,
    before: null,
    page_size: 0,
    total_count: 0,
  },
};

const calenderEventsReducer = produce((draft, action) => {
  switch (action.type) {
    case CALENDER_EVENTS[CALENDER_EVENTS_ACTION_KEYS.GET_SUMMARY].LOAD: {
      draft.apiStatus = API_STATUS.LOADING;
      break;
    }
    case CALENDER_EVENTS[CALENDER_EVENTS_ACTION_KEYS.GET_SUMMARY].SUCCESS: {
      draft.apiStatus = API_STATUS.SUCCESS;
      const newEvents =
        action.result.result.events?.map(event => {
          const { title, description, date, id } = event;
          const [shortTitle = '', longTitle = ''] = title?.split(':') || [];
          return {
            id,
            date,
            shortTitle: shortTitle.trim(),
            longTitle: longTitle.trim(),
            // The event description string coming from backend may contain \\n for new line, we split description based on this character.
            descriptionLines:
              description?.split('\\n').map(string => string.trim()) || [],
          };
        }) || [];
      const groupedByDate = groupBy((event: CalenderEvent) => {
        return getEventFormatedDate(event.date);
      }, newEvents);

      draft.events = groupedByDate;
      draft.meta = action.result.result.meta;
      break;
    }
    case CALENDER_EVENTS[CALENDER_EVENTS_ACTION_KEYS.GET_SUMMARY].FAIL: {
      draft.apiStatus = API_STATUS.ERROR;
      break;
    }
    default:
      break;
  }
}, INITIAL_STATE);

export { calenderEventsReducer };
